import { CommonModule } from '@angular/common'
import { ComponentsComponent } from './components/components.component'
import { ComponentsRowComponent } from './components-row/components-row.component'
import { ComponentsRowHeaderComponent } from './components-row-header/components-row-header.component'
import { DeliverableSectionsComponent } from './deliverable-sections/deliverable-sections.component'
import { DeliverableSectionsHeaderComponent } from './deliverable-sections-header/deliverable-sections-header.component'
import { DeliverableSectionsRowComponent } from './deliverable-sections-row/deliverable-sections-row.component'
import { DeliverablesComponent } from './deliverables/deliverables.component'
import { DeliverablesRowComponent } from './deliverables-row/deliverables-row.component'
import { DeliverablesRowHeaderComponent } from './deliverables-row-header/deliverables-row-header.component'
import { DepartmentsComponent } from './departments/departments.component'
import { DepartmentsHeaderComponent } from './departments-header/departments-header.component'
import { DepartmentsRowComponent } from './departments-row/departments-row.component'
import { FeesComponent } from './fees/fees.component'
import { MatIconModule } from '@angular/material/icon'
import { MaterialModule } from '@app/plugins/material/material.module'
import { NgModule } from '@angular/core'
import { NgxMaskDirective } from 'ngx-mask'
import { RolesComponent } from './roles/roles.component'
import { RolesHeaderComponent } from './roles-header/roles-header.component'
import { RolesRowComponent } from './roles-row/roles-row.component'
import { ScopeUiCounterComponent } from '../ui-components/scope-ui-counter/scope-ui-counter.component'
import { ScopeUiDatepickerComponent } from '../ui-components/scope-ui-datepicker/scope-ui-datepicker.component'
import { ScopeUiDropdownComponent } from '../ui-components/scope-ui-dropdown/scope-ui-dropdown.component'
import { ScopeUiInputComponent } from '../ui-components/scope-ui-input/scope-ui-input.component'
import { ScopeUiTableComponent } from '../ui-components/scope-ui-table/scope-ui-table.component'
import { SharedModule } from '@app/shared/shared.module'
import { ThirdPartyCostsComponent } from './third-party-costs/third-party-costs.component'

const components = [
  DeliverablesComponent,
  DeliverablesRowHeaderComponent,
  DeliverablesRowComponent,
  ComponentsComponent,
  ComponentsRowHeaderComponent,
  ComponentsRowComponent,
  DepartmentsComponent,
  DepartmentsHeaderComponent,
  DepartmentsRowComponent,
  RolesComponent,
  RolesHeaderComponent,
  RolesRowComponent,
  DeliverableSectionsComponent,
  DeliverableSectionsHeaderComponent,
  DeliverableSectionsRowComponent,
  ThirdPartyCostsComponent,
  FeesComponent,
]

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    MaterialModule,
    MatIconModule,
    ScopeUiTableComponent,
    NgxMaskDirective,
    ScopeUiCounterComponent,
    ScopeUiInputComponent,
    ScopeUiDatepickerComponent,
    ScopeUiDropdownComponent,
  ],
  declarations: components,
  exports: components,
  providers: [],
})
export class ScopeElementsModule {}
